export default __webpack_public_path__ + "media/images/promare/promare-901c69366812ba0aa29f548c2b764d07.jpg";